export class LoadingHelper {
    private static instance: LoadingHelper;
    private isLoading: boolean = false;

    public static getInstanace(): LoadingHelper {
        if(!LoadingHelper.instance){
            LoadingHelper.instance = new LoadingHelper();
        }

        return LoadingHelper.instance;
    }

    public setIsLoading(value: boolean){
        this.isLoading = value;
    }

    public getIsLoading() {
        return this.isLoading;
    }
}